import { DEFAULT_LOCALE } from './currency-format';
export function dateFormat(_a) {
    var _b = _a.locale, locale = _b === void 0 ? DEFAULT_LOCALE : _b;
    // tslint:disable-next-line:no-string-literal
    var Intl = typeof window === 'undefined' ? null : window['Intl'];
    return Intl
        ? new Intl.DateTimeFormat(locale.replace('_', '-'), {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        }).format
        : fallback;
}
var fallback = function (date) { return new Date(date).toLocaleDateString(); };
var isUtcBeforeFix = function (utcDate) {
    return utcDate.getUTCHours() !== 0 ||
        utcDate.getUTCMinutes() !== 0 ||
        utcDate.getUTCSeconds() !== 0;
};
export var localDate = function (formatter) { return function (utcDate) {
    return isUtcBeforeFix(utcDate)
        ? formatter(utcDate)
        : formatter(new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate()));
}; };
//# sourceMappingURL=date-format.js.map